import {Fragment} from "react";
import TopNavigation from "../components/TopNavigation/TopNavigation";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import BudgetEntry from "../components/GL/BudgetEntry";
import DebtReport from "../components/Debt/DebtReport";
import DebtEntry from "../components/Debt/DebtEntry";
import RestaurantReport from "../components/Report/RestaurantReport";

export default function GlPage(){



    return(
        <Fragment>
            <TopNavigation/>
            <div className="purchaseDiv text-center mergin_top">
                <RestaurantReport/>
            </div>
        </Fragment>
    )
}
